export default __webpack_public_path__ + "static/media/actions.b247f69d.svg";